import { useMutation } from '@tanstack/react-query';

import apiHelper from '@/apiHelper';
import { CreateNookRequest } from '@/types/nook';

const useCreateNookMutation = () => {
  return useMutation({
    mutationFn: async (data: CreateNookRequest) => {
      const response = await apiHelper.post('/api/nook/create', data);
      return response.data;
    },
  });
};

export default useCreateNookMutation;
